import * as React from 'react';

import ProductModel from 'src/model/product.model';

import ProductCardBox from 'src/components/ProductCardBox/ProductCardBox';
import PartCardLoading from 'src/components/common/PartCardLoading';
import Paginator from 'src/components/common/Paginator';

import './ProductCatalogBox.scss';
import SubcategoryModel from 'src/model/subcategory.model';
import { ifLoggedIn, goToPartDetail } from 'src/utils/navigation';
import CustomPaginator from '../common/CustomPaginator';

interface IProductsCatalogProps {
  subcategory?: SubcategoryModel;
  products: ProductModel[];
  emptyMessage?: string;
  loading: boolean;
  paginator: any;
  handlePageChange(event: any): any;
  handleToggleFavorite?(
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ): void;
  handlepageSizeChange(event: any): any;
  fireProductClickEvent(data: any): void;
}

export default class ProductCatalogBox extends React.Component<
  IProductsCatalogProps,
  any
> {
  public handleBuyNow = (productId: string) => {
    const productClicked = this.props.products.find(
      (product: any) =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.props.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private renderContent = () => {
    if (this.props.loading) {
      return (
        <div className="rp-parts-catalog-grid loading">
          {this.renderLoadingElements()}
        </div>
      );
    } else if (this.props.products.length !== 0) {
      return (
        <div className="rp-parts-catalog-grid">
          {this.renderProducts()}
          {this.generateTrailingElements()}
        </div>
      );
    } else {
      return this.renderEmptyList();
    }
  };

  /* 
    generateTrailingElements: This function creates invisible elements to fill 
    the grid when using IE
   */
  private generateTrailingElements = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      return (
        <React.Fragment>
          <div className="rp-product-catalog-grid--product-trailing" />
          <div className="rp-product-catalog-grid--product-trailing" />
          <div className="rp-product-catalog-grid--product-trailing" />
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  };

  private renderProducts() {
    return this.props.products.map((item, index) => {
      const productImg =
        item.imageUrls &&
        item.imageUrls instanceof Array &&
        item.imageUrls.length !== 0
          ? item.imageUrls[0]
          : '';
      return (
        <div className="rp-parts-catalog-grid--product-box" key={index}>
          <ProductCardBox
            id={item.productNumber}
            part={item}
            name={item.productNumber}
            mfc={item.manufacturerCode}
            description={item.description}
            price={item.partnerPrice}
            msrp={item.retailPrice}
            image={productImg}
            inStock={item.inStock}
            handleOnClicBuyNow={this.handleBuyNow}
            favorite={item.favorite}
            favoriteId={item.idFavoriteItem}
            deal={!!item.discountInfo}
            handleToggleFavorite={this.props.handleToggleFavorite}
            state={item.state}
            stateDescription={item.stateDescription}
          />
        </div>
      );
    });
  }

  private renderEmptyList() {
    return (
      <div className="rp-product-catalog-grid--no-products">
        <i className="rpds-error" />
        <p className="empty-message">{this.props.emptyMessage}</p>
      </div>
    );
  }

  private renderLoadingElements = () => {
    const items = [];
    let i = 0;
    while (i < 9) {
      items.push(
        <div key={i} className="rp-parts-catalog-grid--loading-element">
         <PartCardLoading />
        </div>
      );
      i++;
    }
    return items;
  };

  public render() {
    const { paginator } = this.props;
    return (
      <section className="rp-product-catalog-box">
        {this.renderContent()}
        <div className="rp-product-catalog--paginator">
          {this.props.products.length !== 0 && !this.props.loading ? (
            <div>
             <div className="product-card-mobile-pagination">   
             <Paginator
               totalPages={paginator.totalPages}
               onPageChanged={this.props.handlePageChange}
               activePage={paginator.pageNumber + 1}
               totalItems={paginator.totalElements}
               itemsPerPage={paginator.pageSize}
             />
             </div>
            <div className="product-card-desktop-pagination"> 
            <CustomPaginator
              activePage={paginator.pageNumber ? paginator.pageNumber + 1 : 1}
              totalPages={paginator.totalPages}
              itemsPerPage={paginator.pageSize}
              onPageChanged={this.props.handlePageChange}
              totalItems={paginator.totalPages * paginator.pageSize}
              showPageInfo={true}
              onPageSizeChange={this.props.handlepageSizeChange}
              showPageRangeChange={false}
              currentPageSize={paginator.pageSize}
            />
            </div>
            </div>
          ) : (
            <span />
          )}
        </div>
      </section>
    );
  }
}
